export default{
  all (context) {
    var params = {
      order: context.order
    }
    context.loading = true
    context.$http.get('previews', {params: params}).then(response => {
      context.loading = false
      context.previews = response.body.data
    })
  },
  get (context, id) {
    context.$http.get('previews/' + id).then(response => {
      context.preview = response.body.data[0]
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/previews.js